export default "__VITE_ASSET__Clt4QUTh__"